
import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './OrchestraMatrixPEP.html?raw';
import connect from 'dojo/_base/connect';
import domGeom from 'dojo/dom-geometry';
import query from 'dojo/query';
import on from 'dojo/on';
import SelectBox from '../../moreCore/UI/SelectBox/SelectBox';
import "../../moreCore/UI/SelectBox/SelectBox";
import "../../moreCore/UI/Button/Button";

import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import WeekSelectorPEP from './WeekSelectorPEP/WeekSelectorPEP';

import LoadedCalendarWeek from '../SharedTypes/LoadedCalendarWeek';
import SelectionStateManagerPEP from './SelectionStateManagerPEP/SelectionStateManagerPEP';

import "../SharedTypes/mixed";
import "./OrchestraMatrixPEPTypes";
import { ColorHelpers, StringHelpers, ToasterHelpers } from "../../more/Helpers";
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';


interface MatrixConfig<X = any, Y = any, Z = any> {
	loadContentAPI: string,
	saveAPI: string,
	selectionValuesAPI: string,
	xAxisAPI: string,
	yAxisAPI: string,
	cellClickCheck?: (itemX: X, itemY: Y, cellItem: Z) => boolean;

}
class OrchestraMatrixPEP extends compose(_uiFrameMixin) {
	templateString: any = template;

	private selectionValueSelector: MdsLax<InstanceType<typeof SelectBox>>;
	 
	private dataStatusLabel: HTMLSpanElement;
	private y_Axis: HTMLDivElement;
	private y_Axis_ScrollContainer: HTMLDivElement;
	private x_Axis: HTMLDivElement;
	private x_Axis_ScrollContainer: HTMLDivElement;
	private viewPortNode: HTMLDivElement;
	containerNode: HTMLDivElement;
	 
	private selectionValue: SelectionValueEntity = null;
	private weekSelector: MdsLax<InstanceType<typeof WeekSelectorPEP>>;
	 
	private __opacityTimeout: number;
	private __scrollTimeout: number;
	 
	private _mousePressActive: boolean = false;
	private _lastMouseactiveCellEntry: cellEntry = null;
	 
	private readonly: boolean = false;
	 
	private loadedWeekIds: Array<string> = new Array<string>();
	private loadedWeekObjects: Array<LoadedCalendarWeek> = new Array<LoadedCalendarWeek>();
	 
	private maxRows: number = 0;
	private maxCells: number = 0;
	private cellHeight: number = 35;
	private cellWidth: number = 35;
	private cellBorder: object = {
		"left": 0,
		"right": 1,
		"top": 1,
		"bottom": 0,
		"color": "gray",
		"style": "dotted"
	};
	private cellBorderBold: object = {
		"left": 0,
		"right": 1,
		"top": 1,
		"bottom": 0,
		"color": "black",
		"style": "solid"
	};
	private colors: object = { // farben der Contentcells
		"entity": "#FFFFFF",
		"group": "#ededeb"
	};
	private OpacityScroll: boolean = false; // abblenden während dem Scrollen

	private _data_Content: ItemContainer<PepMatrixDataItem_Content>;
	private _data_X: ItemContainer<PepMatrixDataItem_X>;
	private _data_Y: ItemContainer<PepMatrixDataItem_Y>;
	private _data_SelectionValues: Array<SelectionValueEntity>;
	 
	private _rows: Record<number, rowEntry>;
	private _cells: Record<string, cellEntry>;
	private _registry_X: Array<PepMatrixDataItem_X> = new Array<PepMatrixDataItem_X>();
	private _registry_Y: Array<PepMatrixDataItem_Y> = new Array<PepMatrixDataItem_Y>();
	 
	private _nodeToDataItem: Array<{ node: HTMLElement, item: DataItem }> = [];
	 
	private _visibleIDs_X: Record<number, string>;
	private _visibleIDs_Y: Record<number, string>;

	private _visibleItems_X: Record<number, PepMatrixDataItem_X>;
	private _visibleItems_Y: Record<number, PepMatrixDataItem_Y>;
	 
	private _nodes_X: Array<HTMLElement> = new Array<HTMLElement>();
	private _nodes_Y: Array<HTMLElement> = new Array<HTMLElement>();
	 
	private selectionStateManager: MdsLax<InstanceType<typeof SelectionStateManagerPEP>>;
	 
	private directBookingId: string;
	private directProjectId: string;
	 
	mainMenuGlobalSpaceNode: HTMLElement;

	private _collapsedItems_Y: Array<{ node: HTMLElement, item: DataItem }> = [];
	private _collapsedItems_X: Array<DataItem> = [];

	private _config: MatrixConfig;
	private __dojoStartupDone: boolean = false;

	private _setConfigAttr(config: MatrixConfig) {
		if (this.__dojoStartupDone) {
			this.setup(config);
		} else {
			this._config = config;
		}
	}

	setup(config: MatrixConfig) {

		
		this._config = config;
		if (!config) return;
		if (!this.__dojoStartupDone) return;



		this.openWeekSelector();


		this.selectionStateManager.placeAt(this.mainMenuGlobalSpaceNode);
		this.selectionStateManager.on("rollback", lang.hitch(this, this.selectionStateManager_Rollback));
		this.selectionStateManager.on("commit", lang.hitch(this, this.selectionStateManager_Commit));
		this.selectionStateManager.on("beforeCommit", lang.hitch(this, this.selectionStateManager_BeforeCommit));

		if (this.selectionStateManager?.setup) {

			this.selectionStateManager.setup({
				commitAPI: this._config.saveAPI
			});
		}

	}

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        ///

		this.RequestManager.handleAs = "json";
		this.refreshViewPortContent();

		this._subscriptions.push({
			handle: connect.connect(window, "resize", this, "refreshViewPortContent"),
			topic: "windowResize"
		});
		//this.loadData();

		if (this.mainMenuGlobalSpaceNode == null) {
			this.mainMenuGlobalSpaceNode = document.getElementById("mainMenuGlobalSpace");
		}

	}

	private getScrollOffsetIndex_X(): number {
		let firstVisibleItem = this._visibleItems_X[0];
		return this._registry_X.indexOf(firstVisibleItem);
	}

	private getScrollOffsetIndex_Y(): number {
		let firstVisibleItem = this._visibleItems_Y[0];
		return this._registry_Y.indexOf(firstVisibleItem);
	}

	private _onClick_SubstituteManagerButton(): void {
		
	}


	private _onSubstituteManagerCallback(result: number): void {
		if (result == 1) {
			this.openWeekSelector(); // wenn beim Substitutenmanager auf Ok geklickt wurde, dann nochmal die Daten neu laden weil vermutlich neue Musiker hinzugefügt wurden
		}
    }

	private _onClick_WeekSelectorButton(): void {
		//console.log("_onClick_WeekSelectorButton");

		this.openWeekSelector();
	}

	private openWeekSelector(): void {
		this.weekSelector = new WeekSelectorPEP(this.directBookingId, this.directProjectId);

		let dlg = new GenericDialog();

		dlg.enableContentOverflow(true);

		dlg.setup({
			header: "OM_Matrix__ChooseYourParameters",
			content: this.weekSelector.domNode,
			buttonPreset: "okcancel",
			size: "smaller",
			callback: lang.hitch(this, this._onWeekSelectorCallback),
			distinctiveNoCallback: "silentclose",
			closeOnEnter: true,
			closeOnEscape: true,			
		});
		dlg.disableButton("ok");

		on(this.weekSelector, "valid", lang.hitch(this, function (dlg, flag) { dlg.enableButton("ok", !!flag); }, dlg));

		//	Modal-Dlg mittig platzieren
		//
		//this.UiModder.domStyle.set(dlg.modalDlgContentNode, "top", "30%");

		
		this.weekSelector.startup();
    }

	private _onWeekSelectorCallback(result: number) {
		if (result == 1) {
			var filterMode = this.weekSelector.RadioGroup_timeFilterMode.getValue() as string;
			let weekIDs: string[] = null;
			let monthId: string = null;

			if (filterMode == "weeks") {
				// woche(n)
				weekIDs = this.weekSelector.SelectBox_week.getValue();
				if (!weekIDs || !weekIDs.length) {
					this.openWeekSelector();
					return;
				}
			} else {
				// monat
				monthId = this.weekSelector.SelectBox_month.getValue();
				if (monthId == null || monthId == "") {
					this.openWeekSelector();
					return;
				}
			}

			// functionsgruppe
			let functionalGroupIDs: string[] = this.weekSelector.SelectBox_functionalGroups.getValue();
			if (!functionalGroupIDs || !functionalGroupIDs.length) {
				this.openWeekSelector();
				return;
			}

			if (this.weekSelector.directBookingId || this.directBookingId) {
				filterMode = "booking";
			}

			if (this.weekSelector.directProjectId || this.directProjectId) {
				filterMode = "project";
            }

			this.loadData(filterMode, weekIDs?.join(","), monthId, functionalGroupIDs, this.directBookingId ? this.directBookingId : this.weekSelector.directBookingId, this.directProjectId ? this.directProjectId : this.weekSelector.directProjectId);
		}
		this.weekSelector.destroy();
		this.weekSelector = null;
    }

	private loadData(filterMode: string, weekId: string, monthId: string, functionalGroupIDs: string[], directBookingId: string, directProjectId: string): void{
		this.StandbyStart();
		this.clear();
		//this.load_Content();
		this.load_X(filterMode, weekId, monthId, functionalGroupIDs?.join(","), directBookingId, directProjectId);
		this.load_Y(functionalGroupIDs?.join(","), filterMode, weekId, monthId, directBookingId, directProjectId);
		this.load_SelectionValues();
	}

	private checkLoadingState(): void {

		if (this._data_Content == null && this._data_X != null && this._data_Y != null) {
			// X und Y vorhanden, aber content fehlt noch
			this.load_Content();
			return;
		}

		if (this._data_Content != null && this._data_X != null && this._data_Y != null) {
			// alles vorhanden. dann kann mit dem initialien zeichnen der DAten begonnen werden
			this.calcVisibleIds();
			this.mapDataToViewPort();
			this.refreshViewPortContent();
			this.StandbyStop();

			this.y_Axis.scrollTop = 0;
		}
	}

	private _onClick_LoadContentCellsButton(): void{
		this.StandbyStart();
		this.load_Content();
	}

	private selectionStateManager_Rollback(): void {
		if (confirm(this.getTranslation("OM_Matrix__RollbackMsg"))) {
			this.StandbyStart();
			this.load_Content();

			this.selectionStateManager.ClearStack();
		}
	}
	private selectionStateManager_BeforeCommit(): void {
		this.StandbyStart();
    }

	private selectionStateManager_Commit(result: boolean): void {
		if (result == true) {
			this.selectionStateManager.ClearStack();

			this.load_Content();
		}

		this.StandbyStop();
    }


	private __load_Content_InProgress: boolean = false;

	private load_Content(): void {

		if (this.__load_Content_InProgress == true) {
			return;
        }

		this.__load_Content_InProgress = true;
		let requestData: object = {
			"IDsX": this._getAxisIDs(this._registry_X),
			"IDsY": this._getAxisIDs(this._registry_Y),
		};

		this.RequestManager.callfunction(
			this._config.loadContentAPI, //"Webtool_API_PepMatrix__GetData_ContentCells",
			requestData,
			lang.hitch(this, function (response) {
				this.__load_Content_InProgress = false;
				this._data_Content = response;
				this._processData_Content();
			}),
			lang.hitch(this, function (err) {
				this.__load_Content_InProgress = false;
			})
		);
	}

	private _getAxisIDs(axisRegistry: Array<DataItem_Axis>): Array<string> {
		let resultList: Array<string> = new Array<string>();

		for (let i = 0; i < axisRegistry.length; i++) {
			let entry: DataItem_Axis = axisRegistry[i];

			if (entry.type == "entity") { // braucht man das?? eventuell blöd bei Summenzeilen
				resultList.push(entry.ID);
			}
		}

		return resultList;
    }

	private _processData_Content(): void{
		/*this.UiModder.domAttr.set(this.dataStatusLabel, {
			"innerHTML": "content data loaded",
			"style": {
				"color": "green"
			}
		});*/
		this.UiModder.domClass.add(this.dataStatusLabel, "w3-hide");

		this.checkLoadingState();
	}

	private load_SelectionValues(): void {
		this.RequestManager.callfunction(
			this._config.selectionValuesAPI, //"Webtool_API_PepMatrix__GetData_SelectionValues",
			{ },
			lang.hitch(this, this._processSelectionValues),
			lang.hitch(this, function (err) {
				alert(JSON.stringify(err));
			})
		);
	}

	private _processSelectionValues(items: Array<SelectionValueEntity>) {
		this._data_SelectionValues = items;
		if (this.selectionValueSelector.entries.length == 0) {
			for (let entity of this._data_SelectionValues) {
				this.selectionValueSelector.addOption(entity.ID, entity.code, true);
			}
		}

		this.selectionValueSelector.startup();
		this.refreshSelectionValue();

		this.hideNode(this.selectionValueSelector, !(this.selectionValueSelector?.entries?.length > 1));
	}

	private getSelectionValueEntityByID(ID: string) {
		for (let entity of this._data_SelectionValues) {
			if (entity.ID == ID) {
				return entity;
            }
		}
		return null;
    }

	private load_Y(functionalGroupIDs: string, filterMode: string, weekId: string, monthId: string, directBookingId: string, directProjectId: string): void {

		this.RequestManager.callfunction(
			this._config.yAxisAPI, //"Webtool_API_PepMatrix__GetData_Y",
			{
					"functionalGroupIs": functionalGroupIDs,
					"functionalGroupIds": functionalGroupIDs,
					"functionalGroupId": functionalGroupIDs,
					"week": weekId,
					"filterMode": filterMode,
					"monthId": monthId,
					"directBookingId": directBookingId,
					"directProjectId": directProjectId
				},
			lang.hitch(this, function (response) {
				this._data_Y = response;
				this._processData_Y();
				this.checkLoadingState();
			}),
			function (err) { alert(JSON.stringify(err)); }
		);
	}

	private _redrawY(): void {
		this._registry_Y = [];

		this.UiModder.domConstruct.empty(this.y_Axis);
		this.UiModder.domConstruct.empty(this.y_Axis_ScrollContainer);

		this._processData_Y();
	}

	private _adjustCollapsableIcon(iconNode: HTMLElement, collapsed: boolean) {

		if (!iconNode) {
			return;
		}

		if (this.UiModder.domClass.contains(iconNode, "collapseIconX")) {
			if (collapsed == true) {
				this.UiModder.domClass.remove(iconNode, "fa-chevron-circle-right");
				this.UiModder.domClass.add(iconNode, "fa-chevron-circle-left");
			} else {
				this.UiModder.domClass.remove(iconNode, "fa-chevron-circle-left");
				this.UiModder.domClass.add(iconNode, "fa-chevron-circle-right");
			}
		} else if (this.UiModder.domClass.contains(iconNode, "collapseIconY")) {
			if (collapsed == true) {
				this.UiModder.domClass.remove(iconNode, "fa-chevron-circle-up");
				this.UiModder.domClass.add(iconNode, "fa-chevron-circle-down");
			} else {
				this.UiModder.domClass.remove(iconNode, "fa-chevron-circle-down");
				this.UiModder.domClass.add(iconNode, "fa-chevron-circle-up");
			}
		}
	}

	// click vertial (auf-/zuklappen)
	//
	private _onClick_yItem(item: PepMatrixDataItem_Y, node: HTMLElement, evt: Event) {
		console.log("_onClick_yItem", item);

		let iconNode = node.getElementsByClassName("collapseIconY")[0];
		//console.log("iconNode", iconNode);

		if (!iconNode || item.type != "group") return;

		if (item.type == "group") {

			let groupItems: Array<DataItem> = [];

			for (let i = 0; i < this._nodeToDataItem.length; i++) {
				let entry = this._nodeToDataItem[i];

				if (entry.item["groupID"] == item.ID) {
					groupItems.push(entry.item);

					let alreadyHidden = this.isNodeHidden(entry.node);

					if (alreadyHidden === true) {
						let index = this._collapsedItems_Y.indexOf(entry);
						this._collapsedItems_Y.splice(index, 1);

						entry.item.invisible = false;
					} else {
						this._collapsedItems_Y.push(entry);
						entry.item.invisible = true;

					}

					this.hideNode(entry.node, entry.item.invisible);
				}				
			}
			
			//this.mapDataToViewPort();
			this.refreshViewPortContent();
			//console.log("groupItems", groupItems);

			this._adjustCollapsableIcon(iconNode as HTMLElement, groupItems[0].invisible == true);
		}
	}

	private _onClick_xAxis(item: PepMatrixDataItem_X, node: HTMLElement, evt): void {
		console.log("_onClick_xAxis", item);

		let iconNode = node.getElementsByClassName("collapseIconX")[0];
		console.log("iconNode", iconNode);

		if (item.type == "group") {

			let groupItems = [];

			this._registry_X
			for (let i = 0; i < this._registry_X.length; i++) {
				let subItem = this._registry_X[i];
				let node = this._nodes_X[i];

				if (subItem["groupID"] == item.ID) {
					groupItems.push(subItem);

					let alreadyHidden = this.isNodeHidden(node);

					if (alreadyHidden === true) {
						let index = this._collapsedItems_X.indexOf(subItem);
						this._collapsedItems_Y.splice(index, 1);

						subItem.invisible = false;
					} else {
						this._collapsedItems_X.push(subItem);
						subItem.invisible = true;

					}

					
					this.hideNode(node, subItem.invisible);
				}
			}

			//this._adjustCollapsableIcon(iconNode as HTMLElement, groupItems[0].invisible == true);
			this.refreshViewPortContent();
			console.log("groupItems", groupItems);
		}

	}


	private _processData_Y(): void{
		//	Zeichnen der Zeilen (vertikal)
		//
		//let paddingLeft = 0;
		this._nodes_Y = new Array<HTMLElement>();

		let lastType = null;
		for (let i = 0; i < this._data_Y.items.length; i++) {

			let currentType = this._data_Y.items[i].type;
			let nextType = this._data_Y.items[i+1]?.type;

			////	beim Wechsel von Entity auf Gruppe den Einzug zurücksetzen
			////
			//if (currentType == "group" && lastType == "entity") {
			//	paddingLeft = 0;
			//}

			let icon = "";
			if (currentType == "group" && nextType == "entity") {
				icon = `<i class="fas fa-chevron-circle-up collapseIconY"></i>&nbsp;`;
			}

			let node = this.UiModder.domConstruct.create("div", {
				"innerHTML": icon + this._data_Y.items[i].label,
				className: "matrixYelement " + currentType,
				"style": {
					"height": (this.cellHeight) + "px",
					"borderLeft": this.getCellBorderStyleString("left"),
					"borderRight": this.getCellBorderStyleString("right"),
					"borderTop": this.getCellBorderStyleString("top"),
					"borderBottom": this.getCellBorderStyleString("bottom"),
					//"backgroundColor": (typeof (this._data_Y.items[i].color) == "string" ? this._data_Y.items[i].color : this.colors[currentType]),
					"paddingLeft": (currentType == "entity") ? "16px" : "4px"
				}
			}, this.y_Axis);

			node.setAttribute("data-y", i.toString());

			ColorHelpers.colorNode(node, null, (typeof (this._data_Y.items[i].color) == "string" ? this._data_Y.items[i].color : this.colors[currentType]));

			on(node, "click", lang.hitch(this, this._onClick_yItem, this._data_Y.items[i], node));

			this._nodes_Y.push(node);
			this._registry_Y.push(this._data_Y.items[i]);
			this._nodeToDataItem.push({
				node: node,
				item: this._data_Y.items[i]
			});

			// dummy-node in scrollcontainer erstellen
			// 	y_Axis_ScrollContainer hat einen Inhalt der gleich groß ist wie der Inhalt von y_Axis. Jedoch ist de Inhalt von y_Axis_ScrollContainer unsichtbar und dient nur dazu um einen Scrollbalken zu zeichnen
			//	die Scrollposition von y_Axis_ScrollContainer wird dann auf y_Axis übertragen
			//
			this.UiModder.domConstruct.create("div", {
				"innerHTML": "dummy",
				"style": {
					"height": (this.cellHeight) + "px",
					"borderLeft": this.getCellBorderStyleString("left"),
					"borderRight": this.getCellBorderStyleString("right"),
					"borderTop": this.getCellBorderStyleString("top"),
					"borderBottom": this.getCellBorderStyleString("bottom"),
					"visibility": "hidden"
				}
			}, this.y_Axis_ScrollContainer);

			////	nach jeder gruppe den linken Einzug vergrößern
			////
			//if (currentType == "group") {
			//	paddingLeft += 16;
			//}

			lastType = currentType;
		}

		this.checkLoadingState();
	}

	private load_X(filterMode: string, weekId: string, monthId: string, functionalGroupIDs: string, directBookingId: string, directProjectId: string): void {


		this.RequestManager.callfunction(
			this._config.xAxisAPI,//"Webtool_API_PepMatrix__GetData_X",
			{
				"week": weekId,
				"filterMode": filterMode,
				functionalGroupIds: functionalGroupIDs,
				functionalGroupIs: functionalGroupIDs, // legacy
				functionalGroupId: functionalGroupIDs,
				"monthId": monthId,
				"directBookingId": directBookingId,
				"directProjectId": directProjectId
			},
			lang.hitch(this, function (response) {
				this._data_X = response;
				this._processData_X();
			}), function (err) { alert(JSON.stringify(err)); }
		);
	}

	private _processData_X(): void {
		//	Zeichnen der Spalten (horizontal)
		//
		let createdCells = [];
		let width = 0;

		let segmentLineNode: HTMLDivElement = null;
		let segmentNode: HTMLDivElement = null;
		if (this._data_X.segmentLinePosition != null) { // segmente werden verwendet
			// container der segmente
			segmentLineNode = this.UiModder.domConstruct.create("div", { }) as HTMLDivElement;
			// erstes segment gleich erstellen
			segmentNode = this.UiModder.domConstruct.create("div", { "className": "w3-cell daygroupTop", "innerHTML": "&nbsp;" }, segmentLineNode) as HTMLDivElement;

		}
		// segment-line on top?
		//
		if (this._data_X.segmentLinePosition == "top") {
			this.UiModder.domConstruct.place(segmentLineNode, this.x_Axis);
        }

		let segment_1_text_old: string = undefined;
		let segmentItemCounter: number = 0;

		let segmentNodeOutputCounter = 0;

		for (let i = 0; i < this._data_X.items.length; i++) {
			let currentType = this._data_X.items[i].type;
			let nextType = this._data_X.items[i + 1]?.type;

			//	kalenderwoche des termins merken
			//
			let calendarWeekID = this._data_X.items[i].ref_sys_calendarweek;
			if (typeof (calendarWeekID) != "undefined") {
				if (this.loadedWeekIds.indexOf(calendarWeekID) == -1) {
					this.loadedWeekIds.push(calendarWeekID);
					this.loadedWeekObjects.push({
						"ID": calendarWeekID,
						"label": this._data_X.items[i].ref_sys_calendarweek__label
					});
				}
			}

			if (this._data_X.segmentLinePosition != null) { // segmente werden verwendet
				// das alte segment ist zu ende und ein neues muss erstellt werden
				if (segment_1_text_old != this._data_X.items[i].segment_1_text) {
					segmentNode = this.UiModder.domConstruct.create("div", {
						"innerHTML": this._data_X.items[i].segment_1_text == undefined ? "" : this._data_X.items[i].segment_1_text,
						"className": "w3-cell daygroupTop"
					}, segmentLineNode) as HTMLDivElement;
					segmentItemCounter = 1;
					segmentNodeOutputCounter++;
				} else {
					segmentItemCounter++;
				}

				let additionalWidth = 0;

				if (segmentNodeOutputCounter == 0) {
					additionalWidth = 1;
				}
				let segmentWidth = (this.cellWidth * segmentItemCounter) + additionalWidth + "px";

				this.UiModder.domStyle.set(segmentNode, {
					"width": segmentWidth,
					"borderLeft": this.getCellBorderStyleString("left"),
					"borderRight": this.getCellBoldBorderStyleString("right")
				});
			}

			let icon = "";
			if (currentType == "group" && nextType == "entity") {
				icon = `<i class="fas fa-chevron-circle-left collapseIconY"></i>&nbsp;`;
			}

			let cell = this.UiModder.domConstruct.create("div", {
				"innerHTML": icon + this._data_X.items[i].label,
				"class": "matrixCell_TOP_X flex_row_center",
				"style": {
					//"height": "90%",
					"width": this.cellWidth + "px",
					"borderLeft": this.getCellBorderStyleString("left"),
					"borderRight": this.getCellBorderStyleString("right"),
					//"backgroundColor": (typeof (this._data_X.items[i].color) == "string" ? this._data_X.items[i].color : this.colors[currentType]),
				}
			}, this.x_Axis);

			cell.setAttribute("data-x", i.toString());

			ColorHelpers.colorNode(cell, null, (typeof (this._data_X.items[i].color) == "string" ? this._data_X.items[i].color : this.colors[currentType]));

			on(cell, "click", lang.hitch(this, this._onClick_xAxis, this._data_X.items[i], cell));
			
			createdCells.push(cell);

			width += (this.cellWidth + this.getCellBorderWidth());
			this._registry_X.push(this._data_X.items[i]);

			segment_1_text_old = this._data_X.items[i].segment_1_text;
		}

		this._nodes_X = createdCells;

		// segment-line bottom?
		//
		if (this._data_X.segmentLinePosition == "bottom") {
			this.UiModder.domConstruct.place(segmentLineNode, this.x_Axis);
		}

		// gesamte Container-Breite auf die Summe der Spalten-Breite anpassen
		this.UiModder.domStyle.set(this.x_Axis, {
			"width": width + "px"
		});

		if (this._data_X.segmentLinePosition == "bottom") {
			this.x_Axis_ScrollContainer.scrollTop = 200;
		}

		this.checkLoadingState();
	}

	private _lastOnClick_DataItem: PepMatrixDataItem_X;
	private _onClick_Dlg: MdsLax<InstanceType<typeof GenericDialog>>;

	private clear(): void {
		this.UiModder.domConstruct.empty(this.x_Axis);
		this._registry_X = new Array<PepMatrixDataItem_X>();

		this.UiModder.domConstruct.empty(this.y_Axis);
		this.UiModder.domConstruct.empty(this.y_Axis_ScrollContainer);
		this._registry_Y = new Array<PepMatrixDataItem_Y>();
		this._cells = {};

		this._data_Content = null;
		this._data_X = null;
		this._data_Y = null;

		this._visibleIDs_X = null;
		this._visibleIDs_Y = null;

		this._visibleItems_X = null;
		this._visibleItems_Y = null;

		this.loadedWeekIds = new Array<string>();
		this.loadedWeekObjects = new Array<LoadedCalendarWeek>();
	}

	private blurAllGroupContentCells(): void {
		
		for (let xy in this._cells) {
			let cellEntry = this._cells[xy];
			if (cellEntry.entity != null) {
				if (cellEntry.entity.static === true) {
					continue; // no blur for static entries
				}
			}

			if (cellEntry.type == "group") {
				this.UiModder.domStyle.set(cellEntry.cellNode, "filter", "blur(2px)");
			}
		}
	}

	private calcVisibleIds(): void {
		this.calcVisibleIds_X();
		this.calcVisibleIds_Y();
	}

	private calcVisibleIds_X(startIndex?): void {
		if (typeof (startIndex) == "undefined") {
			startIndex = 0;
		}

		this._visibleIDs_X = {};
		this._visibleItems_X = {};
		let localIndex = -1;;

		for (let i = 0; i < this._registry_X.length; i++) {
			if (i >= startIndex && i <= startIndex + this.maxCells) {
				let item = this._registry_X[i];
				if (!item.invisible) {
					localIndex++;
					this._visibleIDs_X[localIndex] = item.ID;
					this._visibleItems_X[localIndex] = item;
				}
			}
		}
	}
	private calcVisibleIds_Y(startIndex?): void {
		if (typeof (startIndex) == "undefined") {
			startIndex = 0;
		}

		this._visibleIDs_Y = {};
		this._visibleItems_Y = {};
		let localIndex = -1;;
		for (let i = 0; i < this._registry_Y.length; i++) {
			if (i >= startIndex && i <= startIndex + this.maxRows) {
				let item = this._registry_Y[i];
				if (!item.invisible) {
					localIndex++;
					this._visibleIDs_Y[localIndex] = this._registry_Y[i].ID;
					this._visibleItems_Y[localIndex] = this._registry_Y[i];
				}
			}
		}
	}

	private getXY(x: number, y: number): string {
		return StringHelpers.numberToString(x, 6) + ":" + StringHelpers.numberToString(y, 6);
	}

	private refreshViewPortContent(): void {
		// Container leeren
		this.destroyAllRows();

		// breite vom ViewPort auslesen
		//
		let viewPortWidth = this.getViewPortSize().w;

		// Maximale Anzahl Zeilen/Spalten berechnen
		this.maxRows = (this.getViewPortSize().h - 100) / (this.cellHeight + this.getCellBorderHeight());
		this.maxCells = this.getViewPortSize().w / (this.cellWidth + this.getCellBorderWidth());

		this.calcVisibleIds();

		let containerHeight = 0;
		let containerWidth = 0;

		this._rows = {};
		this._cells = {};

		// Zeilen erzeugen
		for (let rowIndex = 0; rowIndex < this.maxRows; rowIndex++) {

			containerWidth = 0;
			let rowNode = this.UiModder.domConstruct.create("div", {
				"class": "matrixRow",
				"style": {
					"height": (this.cellHeight + this.getCellBorderHeight()) + "px"
				}
			}, this.containerNode);

			let rowEntry: rowEntry = {
				"rowNode": rowNode as HTMLDivElement,
				"cells": []
			};

			this._rows[rowIndex] = rowEntry; // row to registry

			// Spalten pro Zeile erzeugen
			for (let cellIndex = 0; cellIndex < this.maxCells; cellIndex++) {
				let cellNode = this.UiModder.domConstruct.create("div", {
					"class": "matrixCell",
					"style": {
						"width": this.cellWidth + "px",
						"height": this.cellHeight + "px",
						"borderLeft": this.getCellBorderStyleString("left"),
						"borderRight": this.getCellBorderStyleString("right"),
						"borderTop": this.getCellBorderStyleString("top"),
						"borderBottom": this.getCellBorderStyleString("bottom")
					}
				}, rowNode);

				let cellEntry: cellEntry = {
					"cellNode": cellNode as HTMLDivElement,
					"entity": null,
					"coordinatesVisible": { x: cellIndex, y: rowIndex }
				};

				let xy = this.getXY(cellIndex, rowIndex);

				cellNode.setAttribute("data-xy", xy);
				cellNode.setAttribute("data-x", cellIndex.toString());
				cellNode.setAttribute("data-y", rowIndex.toString());

				rowEntry.cells.push(cellEntry); // cell to row
				this._cells[xy] = cellEntry;

				containerWidth += (this.cellWidth + this.getCellBorderWidth());
			}

			containerHeight += (this.cellHeight + this.getCellBorderHeight());
		}

		// Container auf Inhaltsgröße anpassen
		//
		this.UiModder.domStyle.set(this.containerNode, {
			"height": containerHeight + "px",
			"width": containerWidth + "px"
		});

		this.UiModder.domStyle.set(this.y_Axis, {
			"height": containerHeight + "px"
		});
		this.UiModder.domStyle.set(this.y_Axis_ScrollContainer, {
			"height": containerHeight + "px"
		});

		this.mapDataToViewPort();
	}

	private _resetContentOpacity(): void{
		if (this.__opacityTimeout) {
			clearTimeout(this.__opacityTimeout);
		}
		this.__opacityTimeout = setTimeout(lang.hitch(this, function () {
			this.UiModder.domStyle.set(this.containerNode, "opacity", 1);
		}), 50);
	}

	private getContentEntryByXY(xyCoord: string): cellEntry {
		if (!xyCoord) return null;
		return this._cells[xyCoord];

	//	for (let rowIndex in this._rows) {
	//		let row = this._rows[rowIndex];
	//		for (let cellIndex = 0; cellIndex < row.cells.length; cellIndex++) {
	//			let cellEntry = row.cells[cellIndex];

	//			if (cellEntry.cellNode == cellNode) {
	//				return cellEntry;
	//			}
	//		}
	//	}
	//	return null;
	}
	
	private _onChange_SelectionValueSelector(): void {
		this.refreshSelectionValue();
	}

	private refreshSelectionValue(): void {
		this.selectionValue = this.getSelectionValueEntityByID(this.selectionValueSelector.getValue());
	}

	private _onMouseDown_Content(evt): void {
		this._mousePressActive = true;
	}

	private _onMouseUp_Content(evt): void {
		this._mousePressActive = false;

	}

	private _onMouseMove_Content(evt): void {
		let cellNode = evt.target as HTMLElement;
		let contentEntry: cellEntry;
		let yNode: HTMLElement;
		let xNode: HTMLElement;
		let x: string;
		let y: string;

		if (cellNode?.getAttribute) {
			let xy = cellNode.getAttribute("data-xy");
			x = cellNode.getAttribute("data-x");
			y = cellNode.getAttribute("data-y");
			
			contentEntry = this.getContentEntryByXY(xy);

		}

		// bestehende Hover-Effekt entfernen:
		let currentHoveredElements = this.domNode.getElementsByClassName("hover");
		if (currentHoveredElements?.length) {
			let items = [];
			for (let index = 0; index < currentHoveredElements.length; index++) {
				items.push(currentHoveredElements.item(index)); // sonst entfernt sich item durch die Manipulation selber aus dem Array!
			}
			this.UiModder.domClass.removeMultiple(items, "hover");
		}

		currentHoveredElements = this.domNode.getElementsByClassName("matrixCell colHover");
		if (currentHoveredElements?.length) {
			let items = [];
			for (let index = 0; index < currentHoveredElements.length; index++) {
				for (let index = 0; index < currentHoveredElements.length; index++) {
					items.push(currentHoveredElements.item(index)); // sonst entfernt sich item durch die Manipulation selber aus dem Array!
				}	
			}

			this.UiModder.domClass.removeMultiple(items, "colHover");
		}


		// falls Zelle: 
		if (contentEntry) {
			if (this._mousePressActive == true) {

				//	Wenn mausklick aktiv und maus über contentcells bewegt wird, dann wird selektion ausgeführt
				//		
				if (contentEntry != this._lastMouseactiveCellEntry) {
					this._lastMouseactiveCellEntry = contentEntry;

					this._handleContentCellSelection(contentEntry);
				}
			}
			this.UiModder.domClass.add(contentEntry.cellNode, "hover");

			let verticalAligned = this.domNode.querySelectorAll("[data-x='" + x + "']");
			if (verticalAligned?.length) {
				for (let i = 0; i < verticalAligned.length; i++) {
					let item = verticalAligned.item(i);
					this.UiModder.domClass.add(item, "colHover");
				}
			}			
		}

		// X und Y auch markieren:
		if (x) {
			// X
			let visibleXNode = this._nodes_X[parseFloat(x) + this.getScrollOffsetIndex_X()];
			if (visibleXNode != null) {
				this.UiModder.domClass.add(visibleXNode, "hover");
			}
		}

		if (y) {
			// Y
			let visibleYNode = this._nodes_Y[parseFloat(y) + this.getScrollOffsetIndex_Y()];
			
			if (visibleYNode != null) {
				this.UiModder.domClass.add(visibleYNode, "hover");
			}
		}

	}

	private _handleContentCellSelection(contentEntry: cellEntry): void {
		if (!contentEntry) return;
		let itemX: PepMatrixDataItem_X = this._visibleItems_X[contentEntry.coordinatesVisible.x];
		let itemY: PepMatrixDataItem_Y = this._visibleItems_Y[contentEntry.coordinatesVisible.y];
		if (itemX == null || itemY == null) {
			return;
		}
		if (itemX.type != "entity" || itemY.type != "entity") {
			return;
		}

		//this._data_Content.items
		//console.log("entity", contentEntry.entity);
		console.log("contentCellSelection", "X: " + itemX.start + " - " + itemX.end, "Y: " + itemY.start + " - " + itemY.end, itemX, itemY);

		let pepTaskStart = new Date(itemY.start);
		let pepTaskEnd = new Date(itemY.end);
		let evTaskStart = new Date(itemX.start);
		let evTaskEnd = new Date(itemX.end);

		if (evTaskStart < pepTaskStart || evTaskEnd > pepTaskEnd) {
			// nix da
			this.UiModder.domClass.add(contentEntry.cellNode, "mds-shake");
			setTimeout(lang.hitch(this, function () {
				this.UiModder.domClass.remove(contentEntry.cellNode, "mds-shake");
			}), 2000);

			ToasterHelpers.showToast("OM_Matrix__Message_PepAssignmentNotPossible", toasterIcons.forbidden);

			return;
		}

		if (contentEntry.entity == null) {
			//	es gibt noch kein Entity auf der Zelle die geklickt wurde. daher erzeugen
			//
			contentEntry.entity = {
				ID: null,
				color: this.selectionValue.coloration.BackColor.Hex,
				label: this.selectionValue.code,
				ref_x: itemX.ID,
				ref_y: itemY.ID
			};

			this._data_Content.items.push(contentEntry.entity);

			this._handleContentSelection_Create(contentEntry.entity);
		} else {
			//	entity existiert schon. entfernen
			//
			this._handleContentSelection_Delete(contentEntry.entity);
			ColorHelpers.colorNode(contentEntry.cellNode, null, null, null);
			let indexInData = this._data_Content.items.indexOf(contentEntry.entity);
			this._data_Content.items.splice(indexInData, 1);
			contentEntry.entity = null;
			//delete contentEntry.entity;
		}

		this.mapDataToViewPort();
    }

	private _onClick_Content(evt): void {
		if (this.readonly == true) {
			return;
        }
		
		//console.log("_onClick_Content", evt, evt.target);
		if (!this.UiModder.domClass.contains(evt.target, "matrixCell")) {
			return; // klick nicht auf eine zelle ausgeführt
		}

		let cellNode = evt.target as HTMLElement;;
		if (!cellNode?.getAttribute) return;
		let xy = cellNode.getAttribute("data-xy");
		if (!xy) return;
		let contentEntry = this.getContentEntryByXY(xy);

		console.debug("_onClick_Content", cellNode, contentEntry, contentEntry.coordinatesVisible);

		this.blurAllGroupContentCells(); // sobald etwas an der Selection geändert wurde, dann die Summenszellen unscharf schalten damit man sieht, dass dieser Wert nicht mehr stimmen muss
		this._handleContentCellSelection(contentEntry);
	}

	private _handleContentSelection_Create(entity: PepMatrixDataItem_Content): void {

		this.blurAllGroupContentCells();
		this.selectionStateManager.addToStack(entity, "create");
	}

	private _handleContentSelection_Delete(entity: PepMatrixDataItem_Content): void {

		this.selectionStateManager.addToStack(entity, "delete");
	}

	private ContentSelection_Create_Response(originEntity: PepMatrixDataItem_Content, newEntity: PepMatrixDataItem_Content): void {
		originEntity.ID = newEntity.ID;
	}

	private ContentSelection_Create_Error(error): void {
		alert(JSON.stringify(error));
	}

	private ContentSelection_Delete_Response(response): void {
		
	}

	private ContentSelection_Delete_Error(error): void {
		alert(JSON.stringify(error));
	}

	private _onScroll_Content(evt): void {

		let scrollTop = this.y_Axis_ScrollContainer.scrollTop;
		let cellHeightWithBorder = this.cellHeight + this.getCellBorderHeight();

		let calculatedIndex = Math.round(scrollTop / cellHeightWithBorder);
		let itemIndex_firstItem = calculatedIndex;

		this.calcVisibleIds_Y(itemIndex_firstItem);

		//	scroll-sync asynchonisieren damit sich das nicht gegenseitig ausbremset wenn mit dem Mausrad gescrollt wird
		//
		setTimeout(lang.hitch(this, function () {
			this.y_Axis_ScrollContainer.scrollTop = this.y_Axis_ScrollContainer.scrollTop + (evt.wheelDelta * (-1) / 3);
		}), 200);


		if (this.__scrollTimeout) {
			clearTimeout(this.__scrollTimeout);
		}

		//this.UiModder.domStyle.set(this.containerNode, "opacity", 0.2);
		//this.__scrollTimeout = setTimeout(lang.hitch(this, function () {
			this.mapDataToViewPort();
		//}), 50);

		//this._resetContentOpacity();
    }

	private _onScroll_X(evt): void {
		let scrollLeft = evt.target.scrollLeft;
		let cellWithWithBorder = this.cellWidth + this.getCellBorderWidth();

		let calculatedIndex = Math.round(scrollLeft / cellWithWithBorder);
		let itemIndex_firstItem = calculatedIndex;

		let firstItem = this._registry_X[itemIndex_firstItem];
		let lastItem = this._registry_X[itemIndex_firstItem + this.maxCells];

		this.calcVisibleIds_X(itemIndex_firstItem);

		// scroll-step anpassen damit immer zu ganzem item gescrollt wird und nie nur ein halbes sichtbar ist
		// hier sollte noch das delty zum vorherigen scroll berechnet werden damit auch der klick auf den balken-pfeil geht
		//
		evt.target.scrollLeft = (itemIndex_firstItem) * cellWithWithBorder;

		if (this.OpacityScroll) {
			this.UiModder.domStyle.set(this.containerNode, "opacity", 0.2);
		}

		if (this.__scrollTimeout) {
			clearTimeout(this.__scrollTimeout);
		}
		this.__scrollTimeout = setTimeout(lang.hitch(this, function () {
			this.mapDataToViewPort();
		}), 50);

		this._resetContentOpacity();
	}

	private _onScroll_Y(evt): void {
		this.y_Axis.scrollTop = evt.target.scrollTop;
	}

	private _onScroll_Y_direct(evt): void {
		let scrollTop = evt.target.scrollTop;
		let cellHeightWithBorder = this.cellHeight + this.getCellBorderHeight();

		let calculatedIndex = Math.round( scrollTop / cellHeightWithBorder);
		let itemIndex_firstItem = calculatedIndex;

		let firstItem = this._registry_Y[itemIndex_firstItem];
		let lastItem = this._registry_Y[itemIndex_firstItem + this.maxRows];

		this.calcVisibleIds_Y(itemIndex_firstItem);

		//	scroll-sync asynchonisieren damit sich das nicht gegenseitig ausbremset wenn mit dem Mausrad gescrollt wird
		//
		setTimeout(lang.hitch(this, function () {
			this.y_Axis_ScrollContainer.scrollTop = evt.target.scrollTop;
		}), 200);

		// scroll-step anpassen damit immer zu ganzem item gescrollt wird und nie nur ein halbes sichtbar ist
		// hier sollte noch das delty zum vorherigen scroll berechnet werden damit auch der klick auf den balken-pfeil geht
		//
		evt.target.scrollTop = (itemIndex_firstItem) * cellHeightWithBorder;

		if (this.__scrollTimeout) {
			clearTimeout(this.__scrollTimeout);
		}

		this.UiModder.domStyle.set(this.containerNode, "opacity", 0.2);
		this.__scrollTimeout = setTimeout(lang.hitch(this, function () {
			this.mapDataToViewPort();
		}), 50);

		this._resetContentOpacity();
	}

	private resetContentArea(): void {
		// der effektive rowindex ist der index der Zeilen im Content-bereich
		// dieser weicht vom visibleRoIndex ab weil diese durch ein/ausblenden der elemente verändert werden
		//
		let effectiveRowIndex = 0;

		//	alle sichtbaren Y-Items von oben nach unten durchlaufen
		//
		for (let visibleRowIndex in this._visibleItems_Y) {
			let item_Y_check = this._visibleItems_Y[visibleRowIndex];
			let item_Y = this._visibleItems_Y[effectiveRowIndex];
			let row = this._rows[effectiveRowIndex];

			if (item_Y_check.invisible === true) {
				continue;
			}

			console.log("resetContentArea", item_Y_check.label, "visibleRowIndex", visibleRowIndex, "effectiveRowIndex", effectiveRowIndex, "originType", item_Y_check.type, "effectiveType", item_Y.type);
		

			// dann von links nach rechts die cells
			//
			let effectiveCellIndex = 0;
			for (let visibleCellIndex = 0; visibleCellIndex < row.cells.length; visibleCellIndex++) {

				let cellEntry = row.cells[effectiveCellIndex];
				let cellNode = cellEntry.cellNode;
				let item_X = this._visibleItems_X[visibleCellIndex];


				this.UiModder.domClass.remove(cellNode, "selectableCell groupCell");

				if (item_X?.invisible === true) {
					continue;
				}

				let selectionItem = this._getSelectionData(item_X, item_Y_check);

				if (selectionItem) {

					try {

						let cellNode = cellEntry.cellNode;
						cellNode.innerHTML = selectionItem.label;
						
						ColorHelpers.colorNode(cellNode, null, ColorHelpers.getHexColorFromString(selectionItem.color));
						//cellNode.style.background = selectionItem.color;
						cellEntry.entity = selectionItem;

						let bIsGroup = false;
						if (item_X.type == "group" || item_Y.type == "group") {
							cellEntry.type = "group"; // wenn X oder Y eine gruppe sind, dann ist der Schnittpunkt auch eine gruppe
							bIsGroup = true;
						}

						this.UiModder.domClass.toggle(cellEntry.cellNode, "groupCell", bIsGroup);

						this.UiModder.domClass.add(cellNode, "selected");

					} catch (ex) {
						//console.error(ex, "visibleIndex_Y", visibleIndex_Y, "visibleIndex_X", visibleIndex_X);
					}

				} else if (item_X) {
					let bIsGroup = false;
					let bIsClickableCell = false;
					if (item_X.type == "group" || item_Y_check.type == "group") {
						bIsGroup = true;
						cellNode.innerText = "";
						//cellNode.style.background = this.colors["group"];
						ColorHelpers.colorNode(cellNode, null, this.colors["group"]);
						
					} else {
						cellNode.innerText = "";
						//cellNode.style.background = "";
						this.UiModder.domClass.remove(cellNode, "selected");
						ColorHelpers.colorNode(cellNode, null, this.colors["entity"]);
						bIsClickableCell = true;
					}

					this.UiModder.domClass.toggle(cellNode, "groupCell", bIsGroup);
					this.UiModder.domClass.toggle(cellNode, "selectableCell", bIsClickableCell);

					cellEntry.entity = null;
				}

				effectiveCellIndex++;
			}

			effectiveRowIndex++;
		}
	}

	
	private _getSelectionData(pItem_X: PepMatrixDataItem_X, pItem_Y: PepMatrixDataItem_Y): PepMatrixDataItem_Content {

		if (!pItem_X || !pItem_Y) {
			return null;
		}

		if (typeof (this._data_Content.items) == "undefined" ) {
			return null;
		}

		for (let selectionItemIndex = 0; selectionItemIndex < this._data_Content.items.length; selectionItemIndex++) {
			let selectionEntity = this._data_Content.items[selectionItemIndex];

			if (selectionEntity.ref_x == pItem_X.ID && selectionEntity.ref_y == pItem_Y.ID) {
				return selectionEntity;
			}
		}
	}

	private mapDataToViewPort(): void {
		if (this._data_Content == null) {
			return;
		}
		// alles alte löschen
		//			
		this.resetContentArea();

	}

	private destroyAllRows(): void {
		query(".matrixRow", this.containerNode).forEach(function (rowNode) {
			query(".matrixCell", this.containerNode).forEach(function (cellNode) {
				this.UiModder.domConstruct.destroy(cellNode);
			}, this);
			this.UiModder.domConstruct.destroy(rowNode);
		}, this);
	}

	private getViewPortSize(): dojo.DomGeometryBox {
		if (!this.viewPortNode) {
			return null;
		}
		return domGeom.getMarginBox(this.viewPortNode);
	}

	private getCellBoldBorderStyleString(position): any {
		return this.cellBorderBold[position] + "px " + this.cellBorderBold["style"] + " " + this.cellBorderBold["color"];
	}
	private getCellBorderStyleString(position): any {
		return this.cellBorder[position] + "px " + this.cellBorder["style"] + " " + this.cellBorder["color"];
	}

	private getCellBorderWidth(): number {
		return this.cellBorder["left"] + this.cellBorder["right"];
}

	private getCellBorderHeight(): number {
		return this.cellBorder["top"] + this.cellBorder["bottom"];
	}

    startup(): void {
		super.startup.apply(this, arguments as any);

		let footer = document.getElementById("mainFooter");
		let computedStyle = window.getComputedStyle(footer);

		let heightStr = computedStyle.height;
		let marginStr = computedStyle.marginTop;

		let footerHeight = parseInt(heightStr.replace('px', ''));
		let footerMargin = parseInt(marginStr.replace('px', ''));

		if (footer) {
			let height = footerHeight + footerMargin;
			let main = this.domNode;// document.getElementById("matrixMain");
			main.style.setProperty("--footerHeight", height + "px");
		}



		this.__dojoStartupDone = true;

		if (this._config) this.setup(this._config);


        //this.inherited(arguments);

		
		//	overflow vom body entfernen damit die ganze seite nicht am body scrollt
		//
		//window.document.body.style.overflow = "hidden";
    }
}

mdsLazyProto(OrchestraMatrixPEP.prototype, {
  selectionStateManager: () => (new SelectionStateManagerPEP()),
});
export default mdsWidget(OrchestraMatrixPEP);